/**
 * Page mapping utilities — convert between char offsets, line indices,
 * and page numbers using `page_body_offsets`.
 *
 * Backend contract (see backend/app/src/data_ingestion/ocr.py
 * `_join_pages_with_offsets` and `models/document.py`):
 * `page_body_offsets[i]` = char index in body where page (i+1) begins.
 * The array always starts with `0` (page 1 begins at offset 0).
 */

/** Convert a body char offset to a 1-based page number using page_body_offsets. */
export function charOffsetToPageNumber(charOffset: number, pageBodyOffsets?: number[]): number | undefined {
    if (!pageBodyOffsets || pageBodyOffsets.length === 0) return undefined;
    for (let i = pageBodyOffsets.length - 1; i >= 0; i--) {
        if (charOffset >= pageBodyOffsets[i]) return i + 1;
    }
    return 1;
}
